import { loadStripe } from '@stripe/stripe-js'

class StripeService {
  constructor() {
    this.stripePromise = null
    this.initializeStripe()
  }

  initializeStripe() {
    // Try multiple possible environment variable names
    const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || 
                          import.meta.env.STRIPE_PUBLIC_KEY ||
                          'pk_test_51SAhIGCff8mDk0lRR3BTmCmiMoKFdHOWZeduxCBYNPgLdkTZzva4A02BNVqTOujOswmWetKh8aPMCxVPp8smbbBu00V1MS5QQg'
    
    if (!publishableKey) {
      console.warn('⚠️ Stripe publishable key not found. Stripe checkout will not work.')
      console.warn('💡 To fix this, add VITE_STRIPE_PUBLISHABLE_KEY to your .env file')
      console.warn('💡 Or add STRIPE_PUBLIC_KEY to your Vercel environment variables')
      console.warn('💡 Get your key from: https://dashboard.stripe.com/apikeys')
      return
    }

    this.stripePromise = loadStripe(publishableKey)
    console.log('✅ Stripe initialized with publishable key')
  }

  async createCheckoutSession(planType, userId, userEmail, billingPeriod = 'monthly') {
    try {
      console.log(`🛒 Creating Stripe checkout session for ${planType} plan...`)
      
      // Call Vercel API to create checkout session
      const response = await fetch('/api/checkout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          planType,
          userId,
          userEmail,
          billingPeriod,
          successUrl: `${window.location.origin}/subscription?success=true`,
          cancelUrl: `${window.location.origin}/subscription?canceled=true`,
        }),
      })

      if (!response.ok) {
        const errorData = await response.json()
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorData.error}`)
      }

      const result = await response.json()
      const { sessionId, url } = result
      console.log('✅ Checkout session created:', sessionId)

      // Redirect to Stripe Checkout
      if (this.stripePromise) {
        const stripe = await this.stripePromise
        const { error } = await stripe.redirectToCheckout({
          sessionId,
        })

        if (error) {
          console.error('❌ Stripe checkout error:', error)
          throw error
        }
      } else if (url) {
        // Fallback: redirect directly to the checkout URL
        console.log('⚠️ Stripe not initialized, redirecting directly to checkout URL')
        window.location.href = url
      } else {
        throw new Error('Stripe not initialized and no checkout URL available. Please check your publishable key.')
      }
    } catch (error) {
      console.error('❌ Error creating checkout session:', error)
      throw error
    }
  }

  // Get plan price IDs (you'll need to replace these with your actual Stripe price IDs)
  getPriceId(planType) {
    const priceMap = {
      'pro': 'price_pro_monthly', // Replace with your actual Stripe price ID
      'premium': 'price_premium_monthly', // Replace with your actual Stripe price ID
      'enterprise': 'price_enterprise_monthly', // Replace with your actual Stripe price ID
    }

    return priceMap[planType]
  }

  // Get plan display name
  getPlanDisplayName(planType) {
    const nameMap = {
      'pro': 'Pro',
      'premium': 'Premium', 
      'enterprise': 'Enterprise',
    }

    return nameMap[planType] || planType
  }
}

export default new StripeService()
